import { push } from 'react-router-redux'

export default store => next => async action => {
  if (!action.redirectTo) return next(action)

  // TODO: DEBUG THIS; Should we send current action first, or redirect first..?
  // eg. We want LOGIN_SUCCESS before going to /account or whatever...
  let nextAction = await next(action)
  store.dispatch(push(action.redirectTo))
  return nextAction
}



// WEBPACK FOOTER //
// ./src/middleware/redirectTo.js